import React from "react"

import LinkWithArrowDeprecated from "../../../design-system/link-with-arrow-deprecated"
import Title from "../../../design-system/title"
import { CaseStudyPageContext } from "../types"
import CaseStudyArticle from "./case-study-article"
import CaseStudySidebar from "./case-study-sidebar"
import * as styles from "./index.module.scss"

const CaseStudyContent = (props: CaseStudyPageContext) => {
  const { title } = props
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <LinkWithArrowDeprecated
          to="/case-studies"
          text="Back to case studies"
          arrowDirection="left"
        />
        <div className={styles.mainContent}>
          <Title as="h1">{title}</Title>
          <CaseStudyArticle {...props} />
          <CaseStudySidebar {...props} />
        </div>
      </div>
    </div>
  )
}

export default CaseStudyContent
